module.exports = __webpack_public_path__ + "img/discovery.5b8c1281.png";